import Axios from 'axios'
import {
	ICrudApplyProviderAttrFilters,
	ICrudApplyProviderAttrIndividual,
	ICrudProviderAttrGlobalAssign,
	ICrudProviderAttrGlobalAssignConfirm,
	ICrudProviderAttrGlobalAssignEdit,
	ICrudProviderAttrGlobalAssignPaginate
} from 'models/ProviderGlobalUploadInterface'

export const providerAttrGlobalApply = async (
	params: ICrudApplyProviderAttrFilters
) => {
	const response = await Axios.post(
		`conf_atrib_global_proveedor/seleccionar`,
		params
	)
	return response.data
}

export const providerAttrIndividualApply = async (
	params: ICrudApplyProviderAttrIndividual
) => {
	const response = await Axios.post(
		`Conf_atrib_global_proveedor/editar/confirmar `,
		params
	)
	return response.data
}
export const providerAttrGlobalAssign = async (
	params: ICrudProviderAttrGlobalAssign
) => {
	const response = await Axios.post(
		`Conf_atrib_global_proveedor/asignaGlobal `,
		params
	)
	return response.data
}
export const providerAttrGlobalAssignConfirm = async (
	params: ICrudProviderAttrGlobalAssignConfirm
) => {
	const response = await Axios.post(
		`Conf_atrib_global_proveedor/confirmar `,
		params
	)
	return response.data
}

export const providerAttrGlobalAssignEdit = async (
	params: ICrudProviderAttrGlobalAssignEdit
) => {
	const response = await Axios.get(
		`Conf_atrib_global_proveedor/editar?idOperacion=${params.idOperacion}&niprov=${params.niprov}`
	)
	return response.data
}
export const providerAttrGlobalAssignPaginate = async (
	params: ICrudProviderAttrGlobalAssignPaginate
) => {
	const response = await Axios.post(
		`Conf_atrib_global_proveedor/paginar `,
		params
	)
	return response.data
}
